export { SurveyPage as default } from '@/components/pages/SurveyPage';
